<template>
  <div class="course-add">
    <div class="course-choose-title-container">
      <div class="course-choose-title">
        请选择需要添加的科目，已选择<span class="course-count">{{
          selectedCourseNumber
        }}</span
        >个科目
      </div>
    </div>
    <div class="course-list-container">
      <div
        class="course-item-container"
        v-for="(item, index) in allCourseList"
        :key="index"
        :class="{ select: item.isSelect }"
        @click="chooseCourse(item)"
      >
        <img
          :src="
            $courseList[item.courseName]
              ? $courseList[item.courseName].courseIcon
              : $courseList['其他'].courseIcon
          "
          class="course-icon"
        />
        <span class="course-name">{{ item.courseName }}</span>
        <div class="course-select-tag" v-show="item.isSelect">
          <i class="iconfont icon-complete icon" />
        </div>
      </div>
    </div>
    <div class="button-container">
      <button
        class="submit-button"
        :disabled="selectedCourseList.length == 0"
        :class="{ 'not-selected': selectedCourseList.length == 0 }"
        @click="submitSelectedCourseList"
      >
        添加
      </button>
      <button class="cancel-button" @click="cancel">取消</button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
export default {
  props: {
    courseList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      selectedCourseNumber: 0,
      selectedCourseList: [],
      allCourseList: [
        {
          courseName: "语文",
        },
        {
          courseName: "数学",
        },
        {
          courseName: "英语",
        },
        {
          courseName: "政治",
        },
        {
          courseName: "历史",
        },
        {
          courseName: "地理",
        },
        {
          courseName: "生物",
        },
        {
          courseName: "化学",
        },
        {
          courseName: "物理",
        },
        {
          courseName: "思想品德",
        },
        {
          courseName: "道德与法治",
        },
        {
          courseName: "体育",
        },
        {
          courseName: "音乐",
        },
        {
          courseName: "美术",
        },
        {
          courseName: "信息技术",
        },
      ],
    };
  },
  created() {
    this.allCourseList.forEach((item) => {
      Vue.set(item, "isSelect", false);
    });
    // console.log(this.allCourseList);
  },
  methods: {
    chooseCourse(courseItem) {
      // console.log(courseItem);
      let haveCourse = false;
      if (this.courseList === null) {
        courseItem.isSelect = !courseItem.isSelect;
        this.filterChooseCourse();
        return;
      }
      this.courseList.forEach((item) => {
        if (item.courseName == courseItem.courseName) {
          haveCourse = true;
        }
      });
      if (haveCourse == true) {
        return this.$message.warning("当前科目已存在，请勿重复添加");
      }
      courseItem.isSelect = !courseItem.isSelect;
      this.filterChooseCourse();
    },
    filterChooseCourse() {
      let selectedCourseList = [];
      this.allCourseList.forEach((item) => {
        if (item.isSelect == true) {
          selectedCourseList.push({
            createBy: this.user.id,
            schoolId: this.user.schoolId,
            schoolName: this.user.schoolName,
            courseName: item.courseName,
          });
        }
      });
      this.selectedCourseList = selectedCourseList;
      this.selectedCourseNumber = selectedCourseList.length;
    },
    submitSelectedCourseList() {
      // console.log(this.selectedCourseList);
      this.$emit("submitCourseList", this.selectedCourseList);
      // 清空数据
      setTimeout(() => {
        this.allCourseList.forEach((item) => {
          Vue.set(item, "isSelect", false);
        });
        this.selectedCourseList = [];
        this.selectedCourseNumber = 0;
      }, 100);
    },
    // 取消
    cancel() {
      // 清空数据
      this.allCourseList.forEach((item) => {
        Vue.set(item, "isSelect", false);
      });
      this.selectedCourseList = [];
      this.selectedCourseNumber = 0;
      this.$emit("cancel");
    },
  },
};
</script>

<style scoped lang="scss">
@import "./course-add.scss";
</style>